import { writable } from 'svelte/store'

import type { Payment } from '$lib/types/client_types'

const store = writable([] as Payment[])

export { store as payments }

export const resetPayments = () => {
	store.set([])
}
